import { Box, useTheme } from '@mui/material';
import DashboardNavbar from 'sections/layout/Navbar';
import { useState } from 'react';

interface Props {
	children: any;
	styleObj?: any;
}

export default function NoSideBarPage(props: Props) {
	const theme = useTheme();
	const [open, setOpen] = useState(true);
	const [mobilOpen, setMobilOpen] = useState(false);

	return (
		<Box
			sx={{
				height: '100%',
				width: '100%',
				position: 'relative',
				display: 'flex',
				flexDirection: 'column',
				[theme.breakpoints.down('sm')]: {
					height: '100%',
				},
				...props.styleObj,
			}}
		>
			{props.children}
		</Box>
	);
}
